import { request } from "hooks/useOkoApi/useOkoApi";

const BASE = "admin/cs-reports";

const buildQuery = (params) => {
  const search = new URLSearchParams();
  Object.entries(params || {}).forEach(([key, value]) => {
    if (value === undefined || value === null || value === "") return;
    search.append(key, value);
  });
  const qs = search.toString();
  return qs ? `?${qs}` : "";
};

export const fetchCustomers = () =>
  request(`${BASE}/filters/customers`, { method: "GET" });

export const fetchSchools = (customerId) =>
  request(`${BASE}/filters/schools${buildQuery({ customer_id: customerId })}`, {
    method: "GET",
  });

export const fetchTeachers = ({ customerId, schoolId } = {}) =>
  request(
    `${BASE}/filters/teachers${buildQuery({
      customer_id: customerId,
      school_id: schoolId,
    })}`,
    { method: "GET" }
  );

export const fetchStandards = ({
  customerId,
  schoolId,
  teacherId,
  startDate,
  endDate,
  q,
} = {}) =>
  request(
    `${BASE}/filters/standards${buildQuery({
      customer_id: customerId,
      school_id: schoolId,
      teacher_id: teacherId,
      start_date: startDate,
      end_date: endDate,
      q,
    })}`,
    { method: "GET" }
  );

const reportPath = (slug, params) =>
  `${BASE}/reports/${slug}${buildQuery(params)}`;

const fetchReportJson = async (slug, params) => {
  const data = await request(reportPath(slug, { ...params, format: "json" }), {
    method: "GET",
  });
  if (Array.isArray(data)) return { rows: data, rowCount: data.length };
  const rows = Array.isArray(data?.rows) ? data.rows : [];
  return { rows, rowCount: data?.row_count ?? rows.length };
};

const fetchReportCsv = (slug, params) =>
  request(reportPath(slug, { ...params, format: "csv" }), { method: "GET" });

export const fetchSummaryByTeacher = (params) =>
  fetchReportJson("summary-by-teacher", params);
export const downloadSummaryByTeacherCSV = (params) =>
  fetchReportCsv("summary-by-teacher", params);

export const fetchDosageTrend = (params) => fetchReportJson("dosage-trend", params);
export const downloadDosageTrendCSV = (params) => fetchReportCsv("dosage-trend", params);

export const fetchGroupCollabTrend = (params) =>
  fetchReportJson("group-collab-trend", params);
export const downloadGroupCollabTrendCSV = (params) =>
  fetchReportCsv("group-collab-trend", params);

export const fetchStudentCollabTrend = (params) =>
  fetchReportJson("student-collab-trend", params);
export const downloadStudentCollabTrendCSV = (params) =>
  fetchReportCsv("student-collab-trend", params);

export const fetchStudentProficiencyBuckets = (params) =>
  fetchReportJson("student-proficiency-buckets", params);
export const downloadStudentProficiencyBucketsCSV = (params) =>
  fetchReportCsv("student-proficiency-buckets", params);

export const triggerCsvDownload = async (response) => {
  const contentDisposition = response.headers.get("Content-Disposition");
  let filename = "cs_report.csv";
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^"]+)"?/);
    if (match && match[1]) filename = match[1];
  }
  const blob = await response.blob();
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(a.href);
};
